import { useAccess } from "../../context/AccessContext";
import { hasPermission } from "../../utils/accessHelpers";

export default function RequirePermission({ permission, children }) {
  const { access, loading } = useAccess();

  if (loading) return <div className="p-6">Loading...</div>;

  if (!hasPermission(access, permission)) {
    return <div className="p-6 text-red-600">Access denied.</div>;
  }

  return children;
}